<div class="page">
    <div class="title">
        <div class="titleValue">{{ "faq.title" | transloco }}</div>
        <div class="line"></div>
    </div>
    <div class="faqsList" *ngFor="let faq of faqs">
        <div class="faqBox">
            <div class="faqBoxTop" (click)="openFaq(faq.id)">
                <div class="faqTitle">{{faq.title}}</div>
                <div class="buttonAmpliar" *ngIf="faqSelected !== faq.id"><mat-icon>add</mat-icon></div>
                <div class="buttonAmpliar" *ngIf="faqSelected === faq.id"><mat-icon>remove</mat-icon></div>
            </div>
            <div class="faqDescription" *ngIf="faqSelected === faq.id">{{faq.description}}</div>
        </div>
    </div>
</div>
